import {Text} from '@dropbox/dig-components/typography';
import {Box} from '@dropbox/dig-foundations';
import type {ReactNode} from 'react';

// List-style section label (sentence case, subtle); 12px above the body, like
// the section cards' headers. `action` sits right after the label (e.g. an edit
// pencil), as on the detail page's section titles.
export const SectionLabel = ({children, action}: {children: ReactNode; action?: ReactNode}) => (
  <Box display="flex" alignItems="center" style={{gap: 4, minHeight: 24, marginBottom: 12}}>
    <Text size="small" isBold color="subtle">
      {children}
    </Text>
    {action}
  </Box>
);
